import { useDataSelector } from './useData';

export const useTheme = () => {
  return useDataSelector('theme');
};
